<template>
  <vs-popup :title="$t('Attachments')" :active.sync="showModal">
    <attach-file-popup
      :show="isShowAttachFilePopup"
      @finish="onfinish"
      @deliveryToCustomerWithReceipt="deliveryToCustomerWithReceipt"
      :packageId="packageId"
    ></attach-file-popup>
    <div class="img-magnifier-container">
      <div id="imgForZoom"></div>
      <img
        v-if="show"
        ref="receiptImg"
        class="block mx-auto my-0 text-center"
        id="myimage"
        @mouseover="magnify('myimage', 2.2)"
        :src="
          URLS_CONSTANTS.assets +
            'PackageAttachments/' +
            PackagereceiptImageInfo
        "
        width="45%"
      />
      <vs-button
        color="success"
        type="gradient"
        size="small"
        icon-pack="feather"
        class="d-inline "
        @click.prevent="onEditReceiptImagePopup()"
      >
        ویرایش عکس رسید</vs-button
      >
    </div>
  </vs-popup>
</template>

<script>
import { URLS_CONSTANTS } from "../../../../config";
import { mapActions } from "vuex";
import AttachFilePopup from "./AttachFilePopup.vue";
export default {
  props: {
    show: { default: false },
    PackagereceiptImageInfo: "",
    packageId: ""
  },
  data() {
    return {
      isShowAttachFilePopup: false,
      test: "",
      URLS_CONSTANTS: URLS_CONSTANTS
    };
  },
  components: {
    AttachFilePopup
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },

  methods: {
    ...mapActions({
      receiptImage: "identityAccess/receiptImage"
    }),
    deliveryToCustomerWithReceipt(newReceiptImage) {
      if (newReceiptImage) {
        newReceiptImage.packageId = this.packageId;
        this.newAddReceiptImage = newReceiptImage;
        this.receiptImage(this.newAddReceiptImage).then(() => {
          this.$swal({
            position: "center-center",
            type: "success",
            text: "عکس موردنظر با موفقیت ویرایش شد",
            showConfirmButton: false,
            timer: 3000
          });
          this.$refs.receiptImg.src = this.newAddReceiptImage.receiptImageContent;
        });
      }
    },
    magnify(imgID, zoom) {
      var img, glass, w, h, bw;
      img = document.getElementById(imgID);
      /*create magnifier glass:*/
      glass = document.getElementById("imgForZoom");
      glass.setAttribute("class", "img-magnifier-glass");
      /*insert magnifier glass:*/
      img.parentElement.insertBefore(glass, img);
      /*set background properties for the magnifier glass:*/
      glass.style.backgroundImage = "url('" + img.src + "')";
      glass.style.backgroundRepeat = "no-repeat";
      glass.style.backgroundSize =
        img.width * zoom + "px " + img.height * zoom + "px";
      bw = 3;
      w = glass.offsetWidth / 2;
      h = glass.offsetHeight / 2;
      /*execute a function when someone moves the magnifier glass over the image:*/
      glass.addEventListener("mousemove", moveMagnifier);
      img.addEventListener("mousemove", moveMagnifier);
      /*and also for touch screens:*/
      glass.addEventListener("touchmove", moveMagnifier);
      img.addEventListener("touchmove", moveMagnifier);
      function moveMagnifier(e) {
        var pos, x, y;
        /*prevent any other actions that may occur when moving over the image*/
        e.preventDefault();
        /*get the cursor's x and y positions:*/
        pos = getCursorPos(e);
        x = pos.x;
        y = pos.y;
        /*prevent the magnifier glass from being positioned outside the image:*/
        if (x > img.width - w / zoom) {
          x = img.width - w / zoom;
        }
        if (x < w / zoom) {
          x = w / zoom;
        }
        if (y > img.height - h / zoom) {
          y = img.height - h / zoom;
        }
        if (y < h / zoom) {
          y = h / zoom;
        }
        /*set the position of the magnifier glass:*/
        glass.style.left = x - w + "px";
        glass.style.top = y - h + "px";
        /*display what the magnifier glass "sees":*/
        glass.style.backgroundPosition =
          "-" + (x * zoom - w + bw) + "px -" + (y * zoom - h + bw) + "px";
      }
      function getCursorPos(e) {
        var a,
          x = 0,
          y = 0;
        e = e || window.event;
        /*get the x and y positions of the image:*/
        a = img.getBoundingClientRect();
        /*calculate the cursor's x and y coordinates, relative to the image:*/
        x = e.pageX - a.left;
        y = e.pageY - a.top;
        /*consider any page scrolling:*/
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return { x: x, y: y };
      }
    },
    onEditReceiptImagePopup() {
      this.isShowAttachFilePopup = true;
    },
    onfinish() {
      this.isShowCostPopup = false;
      this.isShowAttachFilePopup = false;
    }
  }
};
</script>
<style scoped>
.img-magnifier-container {
  position: relative;
}

.img-magnifier-glass {
  position: absolute;
  border: 3px solid #000;
  cursor: none;
  /*Set the size of the magnifier glass:*/
  width: 100%;
  height: 50%;
}
</style>
